import { LEAD_EVENT_STAGES } from '../constants/leadEventStages';

export function getOnboardingResumePath(events = []) {
  const stages = new Set((events || []).map((e) => e.stage));

  if (!stages.has(LEAD_EVENT_STAGES.BASIC_PROFILE)) {
    return '/onboarding/complete-profile';
  }
  if (!stages.has(LEAD_EVENT_STAGES.TRAINING_CERTIFIED)) {
    return '/onboarding/training';
  }
  if (stages.has(LEAD_EVENT_STAGES.EXTERNAL_VALIDATION_REQUEST)) {
    return '/onboarding/pending';
  }
  return '/onboarding/registration';
}

export function isOnboardingPathAllowed(pathname, resumePath) {
  const path =
    pathname.endsWith('/') && pathname.length > 1
      ? pathname.slice(0, -1)
      : pathname;
  const resume =
    resumePath.endsWith('/') && resumePath.length > 1
      ? resumePath.slice(0, -1)
      : resumePath;

  if (path === resume) return true;

  if (resume === '/onboarding/training') {
    return (
      path === '/onboarding/training' ||
      path.startsWith('/onboarding/training/')
    );
  }

  if (resume === '/onboarding/registration') {
    return path.startsWith('/onboarding/registration');
  }

  return false;
}
